import { forwardRef } from "react";

import { cx } from "@/utils";

import styles from "./List.module.css";

export type ListItemProps = {
  children: React.ReactNode;
  active?: boolean;
  className?: string;
  passPadding?: boolean;
  alignContent?: boolean;
  component?: React.ElementType;
};

const ListItem = forwardRef<HTMLLIElement, ListItemProps>(
  (
    {
      children,
      className,
      active,
      passPadding,
      alignContent = false,
      component = "li",
    },
    ref
  ) => {
    const Component = component;

    return (
      <Component
        ref={ref}
        className={cx(
          styles.listItem,
          {
            [styles.alignContent]: alignContent,
            [styles.passPadding]: passPadding,
            [styles.active]: active,
          },
          className
        )}
      >
        {children}
      </Component>
    );
  }
);
ListItem.displayName = "ListItem";

export default ListItem;
